module.exports = __webpack_public_path__ + "static/media/vinatt.f0a16918.jpg";